import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ReactiveFormsModule, FormControl, Validators } from "@angular/forms";
import { ButtonComponent } from "../../../../_shared/form/components/button/button.component";
import { HorizontalTextInputComponent } from "../../../../_shared/form/components/horizontal-text-input/horizontal-text-input.component";
import { Login } from "../../../models/user";
import { MfaSetUpCode } from "../../../models/mfa-set-up-code";
import { UserService } from "../../../services/user.service";

@Component({
  selector: "app-mfa-setup-step",
  templateUrl: "./mfa-setup-step.component.html",
  styleUrls: ["./mfa-setup-step.component.scss"],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ButtonComponent, HorizontalTextInputComponent],
})
export class MfaSetupStepComponent implements OnInit {
  @Input() login!: Login;
  @Input() enforcingOrgName: string | null = null;
  // Geeft de zojuist gevalideerde TOTP-code mee zodat de host direct kan signin'en;
  // anders weet de backend dat MFA nu actief is en weigert hij de signin zonder code.
  @Output() completed = new EventEmitter<string>();

  subStep: 1 | 2 | 3 = 1;
  setupCode: MfaSetUpCode | null = null;
  code = new FormControl("", [Validators.required, Validators.pattern(/^\d{6}$/)]);
  isLoading = false;
  errorMessage: string | null = null;

  constructor(private userService: UserService) {}

  ngOnInit(): void {}

  next(): void {
    if (this.subStep === 1) {
      this.subStep = 2;
      return;
    }
    if (this.subStep === 2) {
      this.isLoading = true;
      this.userService.setupMfaWithPassword(this.login).subscribe(
        (code) => {
          this.setupCode = code;
          this.subStep = 3;
          this.isLoading = false;
        },
        () => {
          this.errorMessage = "Sessie verlopen. Sluit dit venster en log opnieuw in.";
          this.isLoading = false;
        }
      );
    }
  }

  previous(): void {
    if (this.subStep > 1) this.subStep = (this.subStep - 1) as 1 | 2 | 3;
    this.errorMessage = null;
  }

  submitCode(): void {
    if (!this.code.valid) {
      this.code.markAsTouched();
      return;
    }
    this.isLoading = true;
    this.errorMessage = null;
    const payload = { ...this.login, Code: this.code.value ?? "" };
    this.userService.activateMfaWithPassword(payload).subscribe(
      (ok) => {
        this.isLoading = false;
        if (ok) {
          this.completed.emit(this.code.value ?? "");
        } else {
          this.errorMessage = "Code klopt niet. Controleer dat je telefoon de juiste tijd heeft en probeer opnieuw.";
          this.code.setValue("");
        }
      },
      () => {
        this.isLoading = false;
        this.errorMessage = "Er ging iets mis. Probeer opnieuw.";
      }
    );
  }
}
